import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NotificationType } from 'app/types/types'

export interface Banner {
  id: string
  message: string
  type: NotificationType
  visible?: boolean
}

const initialState: Banner = {
  id: '',
  message: '',
  type: 'info',
  visible: false
}

const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    showBanner: (state, action: PayloadAction<Banner>) => {
      state.id = action.payload.id
      state.message = action.payload.message
      state.type = action.payload.type
      state.visible = true
    },
    hideBanner: state => {
      state.visible = false
    }
  }
})

export const { showBanner, hideBanner } = bannerSlice.actions

export default bannerSlice.reducer
